import {useMemo} from 'react';

import {DocumentOnList, Documents} from '../documents';
import {getExcludedDocumentsIdsForJoining} from '../documents/helpers';


export const AnswerTableAttachments = ({
                                         attachments,
                                         canRemove,
                                         controlUuid,
                                         openDocuments,
                                         projectUuid,
                                         onAdd,
                                         onCloseDocuments,
  onRemove
}) => {

  const excludedDocumentsIdsForJoining = useMemo(() => {
    return getExcludedDocumentsIdsForJoining(attachments)
  }, [attachments]);

  return (
    <>
      {attachments.length > 0 &&
        <tr className='quest-second-row'>
          <td colSpan='3'>
            <div className='my-3'>
              <p className='font-weight-bold'>ZAŁĄCZNIKI: </p>
              {attachments.map((attachment, index) =>
                <DocumentOnList
                  canRemove={canRemove}
                  document={attachment.document}
                  key={attachment.id || index}  // attachment may not have id yet
                  onlyRemoveFromList
                  onRemoveDocument={onRemove}
                />
              )}
            </div>
          </td>
        </tr>
      }
      {openDocuments &&
        <tr>
          <td>
            <Documents
                controlUuid={controlUuid}
                excludedDocumentsIdsForJoining={excludedDocumentsIdsForJoining}
                inPopup
                popUpTitle="Dodawanie pliku"
                projectUuid={projectUuid}
                onAddSuccess={onAdd}
                onCancel={onCloseDocuments}
                popupNotScrolled
                saveAsDraft={true}
            />
          </td>
        </tr>
      }
    </>
  )
};
